/**
 * @fileoverview > handler for the "/engagement/:app_group_id/templated_preview" endpoint
 * @owner @Appboy/frontend-ix
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdTemplatedPreviewCacheKeys } from "./constants";
import type { PostTemplatedPreviewRequestProps, PostTemplatedPreviewServerResult } from "./types";

export const postEngagementAppGroupIdTemplatedPreview = reactQueryMutationAdapter(
  engagementAppGroupIdTemplatedPreviewCacheKeys,
  (props: PostTemplatedPreviewRequestProps): Promise<PostTemplatedPreviewServerResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/templated_preview`,
      "POST",
      props,
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
